import { AuthState } from 'src/redesign/pages/Login/types';
import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_NAME } from 'src/redesign/pages/Login/store/constants';
import {
  initialLoginSession,
  loginAction,
  sendPinCode,
  verifyPinCode,
} from 'src/redesign/pages/Login/store/actions';

const initialState: AuthState = {
  currentStep: 'email',
  loading: false,
  error: null,
  codeId: null,
  codeVerified: false,
  email: null,
};

export const loginSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setLoginEmail: (state, action) => {
      state.email = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setLoginError: (state, action) => {
      state.error = action.payload;
    },
    setCodeVerified: (state, action) => {
      state.codeVerified = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initialLoginSession.fulfilled, (state, action) => {
      state.currentStep = action.payload.data.nextStep;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(initialLoginSession.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(initialLoginSession.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(loginAction.fulfilled, (state) => {
      state.currentStep = null;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(loginAction.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(sendPinCode.fulfilled, (state, action) => {
      state.codeId = action.payload.data.codeId;
      state.codeVerified = true;
      state.error = null;
      state.loading = false;
    });
    builder.addCase(sendPinCode.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.codeVerified = false;
    });
    builder.addCase(sendPinCode.rejected, (state, action) => {
      state.loading = true;
      state.error = action.error.message;
      state.codeVerified = 'Failed to send code. Try again later!';
    });
    builder.addCase(verifyPinCode.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
      state.codeVerified = true;
    });
    builder.addCase(verifyPinCode.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.codeVerified = false;
    });
    builder.addCase(verifyPinCode.rejected, (state, action) => {
      state.loading = true;
      state.error = action.error.message;
      state.codeVerified = 'Code is invalid. Try again!';
    });
  },
});

export const setCurrentStepAction = loginSlice.actions.setCurrentStep;
export const setLoginErrorAction = loginSlice.actions.setLoginError;
export const setCodeVerifiedAction = loginSlice.actions.setCodeVerified;
export const setLoginEmailAction = loginSlice.actions.setLoginEmail;
